import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageES() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Análisis de Relaciones con IA | Detecta Patrones Tóxicos y Gaslighting" description="Averigüe si su ex es el problema. Suba sus chats a la IA de ToxicDetector para un análisis instantáneo y confidencial de manipulación, gaslighting y señales de alerta. Comience el escaneo gratuito hoy." keywords="análisis de relaciones con IA, detectar patrones tóxicos, detector de gaslighting, ex tóxico, verificador de manipulación, toxicidad en relaciones, escáner de texto con IA" canonical="https://toxicdetector.com/es" language="es-MX" alternateUrls={alternateUrls} data-id="element-5305" />
      <GoogleTranslateWidget data-id="element-5306" />
      <PromoBanner data-id="element-5307" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-5308">
        <Header data-id="element-5309" />
        <main data-id="element-5310">
          <HeroSection h1Override={<>
                Tu Cerebro Te{' '}
                <span className="relative inline-block" data-id="element-5312">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-5313">
                    Miente
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-5314" />
                </span>
                {'. '}
                <br data-id="element-5315" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-5316">
                  Nuestra IA No.
                </span>
              </>} data-id="element-5311" />
          <TrustSection data-id="element-5317" />
          <FeaturesSection data-id="element-5318" />
          <GuaranteesSection data-id="element-5319" />
          <ToolsSection data-id="element-5320" />
          <ComparisonSection data-id="element-5321" />
          <PricingSection data-id="element-5322" />
          <FAQSection data-id="element-5323" />
          <CTASection data-id="element-5324" />
        </main>
        <Footer data-id="element-5325" />
      </div>
    </>;
}